module.exports = __webpack_public_path__ + "img/xcx.cc63e1cf.jpg";